import { USER_ROLE } from '../../utils/constants';
import CommunityGroupsList from './groups';
import AddUpdateGroups from './groups/addUpdateGroups';
import BlockedUsersList from './groups/blockdedUsers';
import CommunityGroupDetails from './groups/groupDetails';
import PostsList from './groups/posts';
import UpdatePostComments from './groups/posts/comments';
import CommentsList from './groups/posts/comments/list';
import COMMUNITY_LINKS from './links';
import CommunityReportedPostsList from './posts';
import AddUpdatePosts from './posts/addUpdatePosts';

const COMMUNITY_ROUTES = [
  {
    path: COMMUNITY_LINKS.COMMUNITY_GROUPS_LIST,
    exact: true,
    component: CommunityGroupsList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_POSTS_LIST,
    exact: true,
    component: PostsList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_GROUPS_ADD,
    exact: true,
    component: AddUpdateGroups,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_GROUPS_EDIT,
    exact: true,
    component: AddUpdateGroups,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_GROUPS_DETAILS,
    exact: true,
    component: CommunityGroupDetails,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_REPORTED_POSTS_LIST,
    exact: true,
    component: CommunityReportedPostsList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_GROUP_POSTS_ADD,
    exact: true,
    component: AddUpdatePosts,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_GROUP_POSTS_EDIT,
    exact: true,
    component: AddUpdatePosts,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_POST_DETAILS,
    exact: true,
    component: UpdatePostComments,
    role: [USER_ROLE.ADMIN],
  },

  {
    path: COMMUNITY_LINKS.COMMUNITY_POSTS_ADD,
    exact: true,
    component: AddUpdatePosts,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_POSTS_EDIT,
    exact: true,
    component: AddUpdatePosts,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_COMMENTS_LIST,
    exact: true,
    component: CommentsList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: COMMUNITY_LINKS.COMMUNITY_BLOCKED_USERS_LIST,
    exact: true,
    component: BlockedUsersList,
    role: [USER_ROLE.ADMIN],
  },
];

export { COMMUNITY_LINKS, COMMUNITY_ROUTES };
